import { Skeleton } from '@fleet/webshop-ui';

const JourneyCardSkeleton = () => {
  return (
    <>
      <div className="flex flex-col gap-2 rounded-l-xl border border-r-0 border-neutral bg-white px-4 py-3">
        <div className="flex flex-col gap-2">
          {/* Time row: 12:30 - 14:45 */}
          <div className="flex flex-row items-center gap-1 py-1">
            <Skeleton className="h-6 w-14" />
            <Skeleton className="h-6 w-3" />
            <Skeleton className="h-6 w-14" />
          </div>

          {/* Duration and transfers row */}
          <div className="flex w-[200px]">
            <div className="flex w-1/2 flex-row items-center gap-1">
              <Skeleton className="h-3.5 w-3.5 rounded-full" />
              <Skeleton className="h-4 w-12" />
            </div>
            <div className="w-full">
              <Skeleton className="h-4 w-16" />
            </div>
          </div>
        </div>
      </div>
      {/* Price button skeleton */}
      <div className="rounded-r-xl border border-neutral bg-neutral">
        <div className="flex h-full min-h-[100px] w-24 flex-col items-center justify-center gap-1 px-3 py-4 laptop:w-32">
          <Skeleton className="h-8 w-16" />
          <Skeleton className="h-4 w-12" />
        </div>
      </div>
    </>
  );
};

export default JourneyCardSkeleton;
